import { render } from "./aboutView.vue?vue&type=template&id=3390e273&scoped=true"
import script from "./aboutView.vue?vue&type=script&lang=js"
export * from "./aboutView.vue?vue&type=script&lang=js"

import "./aboutView.vue?vue&type=style&index=0&id=3390e273&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3390e273"]])

export default __exports__